(function () {
  /* Product card image carousel — event-delegated rather than
     per-card listeners, since this snippet renders inside several
     different sections (shop, related products, collection, search)
     and a single document-level listener covers all of them without
     needing a section-scoped init/teardown pair. Arrow clicks are
     caught before the card's <a> navigates.

     The snippet that emits this script tag renders once per product
     card, so this file is requested many times per page — guard
     against wiring the delegated listener more than once. */
  if (window.__productCardWired) return;
  window.__productCardWired = true;

  function slideTo(card, index) {
    var slider = card.querySelector('[data-card-slider]');
    if (!slider) return;
    var count = slider.children.length;
    if (!count) return;
    var clamped = ((index % count) + count) % count;
    slider.style.transform = 'translateX(-' + clamped * 100 + '%)';
    card.dataset.cardIndex = clamped;
  }

  document.addEventListener('click', function (e) {
    var prev = e.target.closest('[data-card-prev]');
    var next = e.target.closest('[data-card-next]');
    var button = prev || next;
    if (!button) return;

    var card = button.closest('[data-product-card]');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();

    var current = parseInt(card.dataset.cardIndex, 10) || 0;
    slideTo(card, prev ? current - 1 : current + 1);
  });
})();
